import React from 'react';
import { useTranslation } from 'react-i18next';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (e) => {
    i18n.changeLanguage(e.target.value);
  };

  const currentLang = i18n.language || 'es';
  const isEs = currentLang.startsWith('es');

  return (
    <div className="language-switcher">
      <select 
        value={isEs ? 'es' : 'en'} 
        onChange={changeLanguage}
        style={{
          background: 'transparent',
          color: '#fff',
          border: '1px solid rgba(255,255,255,0.3)',
          borderRadius: '4px',
          padding: '2px 5px',
          fontSize: '14px',
          cursor: 'pointer',
          outline: 'none'
        }}
      >
        <option value="es" style={{ color: '#000' }}>Español</option>
        <option value="en" style={{ color: '#000' }}>English</option>
      </select>
    </div>
  );
};

export default LanguageSwitcher;
